import { Text } from "@seneca/senekit";

import ControlledCheckbox from "seneca-common/utils/form-hook/inputs/ControlledCheckbox";

import { getAppName } from "features/common/utils/functions/app";

type Props = {
  name?: string;
};

export default function MarketingEmailsCheckbox({
  name = "isSubscribedToMarketingEmails"
}: Props) {
  const appName = getAppName();

  return (
    <ControlledCheckbox
      name={name}
      label={
        <Text size="small" tone="neutral" emphasis="medium">
          I want to hear how to boost my child's confidence & grades via extra
          support from {appName} & our partners
        </Text>
      }
    />
  );
}
